import { useQuery } from '@tanstack/react-query';

import { useAuthUserId } from '../../../../selectors/AuthSelectors';
import { useRestaurantId } from '../../../../selectors/RestaurantSelectors';
import { getSectionsRequest } from '../lib';

export function useSectionsQueryKey() {
  return [useAuthUserId(), 'restaurant', useRestaurantId(), 'sections'];
}

export function useSections() {
  const restaurantId = useRestaurantId();

  const {
    data: response,
    isLoading,
    isFetching,
    isFetched,
  } = useQuery({
    staleTime: 60 * 1000 * 30,
    queryKey: useSectionsQueryKey(),
    queryFn: () => getSectionsRequest(restaurantId),
  });

  return {
    isFetched,
    isLoading: isLoading || isFetching,
    data: response?.data,
  };
}
